import TitleBar from './TitleBar.component';

export default TitleBar;
